module.exports = __webpack_public_path__ + "img/bell-off-02.cfe6a885.svg";